import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AdminData } from 'src/app/models/AdminData';
import jwt_decode from 'jwt-decode'
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment.prod';
import { Observable } from 'rxjs/internal/Observable';
import { BehaviorSubject, catchError, map, of, tap, throwError } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AdminService {

  // პროფილის ინფორმაცია
  public user = new AdminData();

  public loading = false
  public error: any

 
  // აუტორიზაციის შემოწმება
  login(value: any) {
  return new Promise(serve => {
    this.loading = true;
    this.http.post(environment.apiUrl + 'auth/login', value, { withCredentials: true }).subscribe((response: any) => {
      this.loading = false;
      this.error = {};

      // აქ response-ში refresh_token არ იქნება, ნუ ეძებ
      if (response.access_token) {
        this.setTokens(response.access_token);
        serve(true);
        return;
      }
      
      serve(false); // თუ access_token არაა
    }, (error: any) => {
      this.loading = false;
      this.error = error;
      serve(false);
    });
  });
}

  // ტოკენის დამახსოვრება
  setTokens(accessToken: string) {
    if (accessToken) {
      localStorage.setItem('@mlUser', accessToken);
      this.parseToken(accessToken);
    }
  }

  getAdminLogin(token: any){
    if(token){
      let d : any
      d = jwt_decode(token)
      if(d.is_admin == 'admin'){
        return true
      }
    }
    return false
  }

  // ტოკენის გაშიფრვა
  parseToken(token: any =''){
    try {
      if (!token) {
        token = localStorage.getItem('@mlUser');
      }
      if(token) {
        this.user.setData(jwt_decode(token));
      }
    } catch (ex) {
      console.log("error: ", ex)
    }
  }

  // არსებობს თუ არა მომხმარებელი
  isAdmin(){
    return this.user.isLogged();
  }

  logout(){
    return this.http.get(environment.apiUrl +  'auth/signin').subscribe(
      () => this.clear(),
      () => this.clear()
    );
  }

  clear() {
    localStorage.removeItem('@mlUser');
    this.user.setData({});
    this.router.navigate(['/signin']);
  }

  refreshToken() {
    return this.http.post<any>(environment.apiUrl + 'auth/refresh', {}, { withCredentials: true }).pipe(
      tap(response => {
        if (response.access_token) {
          this.setTokens(response.access_token);
        }
      })
    );
  }

  setHistory() {
    return this.http.get(environment.apiUrl + 'blogger/user/set/history/' + this.user.id );
  }

  changePassword(data: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'auth/change/password', data);
  }

  changePhone(data: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'auth/change/phone', data);
  }

  signUp(data: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'auth/signup', data);
  }

  getMyInfo(){
    return this.http.get(environment.apiUrl + 'auth/me');
  }


  changeUserInfo(data: any) {
    return this.http.post(environment.apiUrl + 'auth/change/user/info', data);
  }

  // seandVeryCode(data: any){
  //   return this.http.post(environment.apiUrl + 'seand/verify/code', data);
  // }


  // იგზავნება ელ.ფოსტა-ზე ვერიფიკაციის დადასტურების ბმული
  seandVerifyLinkEmail(data: any) {
    return this.http.post(environment.apiUrl + 'seand/verify/link/email', data);
  }

  // იძლევა დასტურს სწორ ბმულზე
  verifyEmail(data: any) {
    return this.http.post(environment.apiUrl + 'verify/email', data);
  }

  // იგზავნება პაროლის აღსადგენი ბმული
  resetPassword(data: any) {
    return this.http.post(environment.apiUrl + 'seand/link/reset/password', data);
  }

  constructor(
    private http: HttpClient,
    private router: Router) {
    this.parseToken()
  }


}
